import { ApiResponse, BaseCreateResponse, BaseResponse, Guid, ListRespone, baseUrl, deleteWithAuth, getWithAuth, patchWithAuth, postWithAuth } from "./baseApi";

export interface MediaTranscodingProfile {
    id: Guid,
    name: string,
    videoFrameRate: number | null,
    videoCodec: string | null,
    videoBitrateKb: number | null,
    videoHeight: number | null,
    videoWidth: number | null,
    audioCodec: string | null,
    audioBitrateKb: number | null,
    audioChannels: number | null,
    audioSampleRate: number | null,
    dynamicsRangeControlEnable: boolean,
    dynamicsRangeControlAmount: string | null,
    filterDynamicEqEnable: boolean,
    filterHighPassEnable: boolean,
    filterHighPassFrequency: number | null,
    filterHumEnable: boolean,
    loudnessEnable: boolean,
    loudnessTargetLevel: number | null,
    loudnessPeakLimit: number | null,
    musicReductionEnable: boolean,
    noiseReductionEnable: boolean,
    noiseReductionAmount: string | null,
    speechClickReductionEnable: boolean,
    speechClickReductionAmount: string | null,
    speechIsolationEnable: boolean,
    speechIsolationAmount: number | null,
    speechPlosiveReductionEnable: boolean,
    speechPlosiveReductionAmount: string | null,
    speechSibilanceReductionEnable: boolean,
    speechSibilanceReductionAmount: string | null,
}

export type MediaTranscodingProfileRequest = Omit<MediaTranscodingProfile,"id">;



// export type SelectOptionNumber = {
//     id: Guid,
//     value: number | "Source"
// }

export const getTranscodingProfiles = async() : Promise<ApiResponse<ListRespone<MediaTranscodingProfile>>> => {
    return await getWithAuth<ListRespone<MediaTranscodingProfile>>({url : `${baseUrl}transcode-profiles`});
}

export const createTranscodingProfile = async(request : MediaTranscodingProfileRequest) : Promise<ApiResponse<BaseCreateResponse>> => {
    return await postWithAuth<MediaTranscodingProfileRequest, BaseCreateResponse>(`${baseUrl}transcode-profiles`, request);
}

export const updateTranscodingProfile = async(id: Guid, request : MediaTranscodingProfileRequest) : Promise<ApiResponse<BaseResponse>> => {
    return await patchWithAuth<MediaTranscodingProfileRequest, BaseResponse>(`${baseUrl}transcode-profiles/${id}`, request);
}

export const deleteTranscodingProfile = async (id: Guid) : Promise<ApiResponse<BaseResponse>> => {
    return await deleteWithAuth<BaseResponse>(`${baseUrl}transcode-profiles`, id); 
}